/* eslint-disable linebreak-style */
import makeRequest from 'utils/makeRequest';
// import { getSiteDomain } from 'utils/common';
import { videoWatchPoints } from 'modules/WithTimesPoint/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Cookie from 'utils/cookies';
import loadPlayerJSFiles from 'utils/loadPlayerJSFiles';
import { pauseOtherPlayers } from './utils';

export default function startPlayer({
  videoMsid,
  divId,
  outsideEventListener,
  nextVideoMsidArray = [],
  store,
  callbackOutside,
  // isPrime,
  isUserPrime,
  slikeId,
  addToWatched,
  sourceVal,
  allowDimVal,
  videoDataReceivedCallback,
  asyncLoadSdkjs,
  audioMode,
  title,
  duration,
  eventsCallbackMap,
  intantiateNewPlayer,
  isPodcast,
  isWapView,
  autoPlay,
}) {
  //  window.parent.$(window.parent.document).trigger has been replaced by a dummy function for now(later to be done in redux)
  //  need to call onVideoUnmount on in componentdidunmount
  const triggerEvent = function triggerEvent(...args) {
    if (typeof outsideEventListener === 'function') {
      outsideEventListener(...args);
    }
  };
  const videoDataReceivedCallbackWrapper = function videoDataReceivedCallbackWrapper(
    data,
  ) {
    if (typeof videoDataReceivedCallback === 'function') {
      videoDataReceivedCallback(data);
    }
  };
  const holdOtherPlayers = function holdOtherPlayers(playerContainerId) {
    if (window && window.player && window.player.length > 0) {
      window.player.forEach((item, index) => {
        if (item.store.clientConfig.contEl !== playerContainerId)
          window.player[index].pause();
      });
    }
  };
  const sliketesting = window.location.href.indexOf('sliketesting') >= 0;
  const testAds = window.location.href.indexOf('testads') >= 0;
  const isMobileMode = isWapView;

  window.reason = {};
  const TimesApps = {};
  TimesApps.VOD_CONF = {
    _default: {
      // showAutoplayButton: false,
      // nextVideoCounter: 5,
      // nextVideoUrl: '/videpostroll_v8/',
      showNextPrevButton: false,
      controlsType: 'custom',
      showAutoPlayNext: true,
      showFwdSeek: true,
      showBackSeek: true,
      autoPlayNext: false,
      showWave: true,
      showShare: false,
      autoPlay,
      autoPlayAudio: true,
      forceWA: true,
      mute: false,
      duration,
    },
    PODCAST: {
      showNextPrevButton: false,
      controlsType: 'custom',
      showAutoPlayNext: true,
      showFwdSeek: true,
      showBackSeek: true,
      autoPlayNext: false,
      showWave: true,
      showShare: false,
      autoPlay,
      autoPlayAudio: true,
      forceWA: true,
      mute: false,
      duration,
    },
  };

  // document.domain = 'indiatimes.com';
  const mainConfig = {
    source: sourceVal, //source is the videoshow for videoshow
    userInitiated: '1',
    mediaId: '', //slike id should be here
    msid: '',
    slikeApiKey: isMobileMode
      ? 'toimweb5t9tCpb7nb5q6jUb'
      : 'toiweba5ec9705eb7ac2c984033e061',
    // TODO: update above key with prod one once v3 keys are live
    // slikeApiKey: isMobileMode ? 'toi371mweb5awm99g9o6' : 'toi371web5awj999ou6',
    nextid: nextVideoMsidArray[1],
    sectionId: '',
    title,
    agency: '',
    duration: duration || '',
    blacklistText: '',
    bgImage: '',
    //'https://static.toiimg.com/thumb/imgsize-199425,msid-#MSID#,width-800,resizemode-4/#MSID#.jpg',
    isVideoInsideBlacklistContent: '0',
    specialId__hyp1: '',
    skipAds: '0',
    volume: 80,
    site: 'TOID',
    playerid: slikeId, //24,
    section: isMobileMode ? 'videos' : 'video-show',
    nextVideoCounter: 5,
    allowDim: allowDimVal ? 1 : 0,
    seoLocation: '',
    mediaDate: '',
    articleId: '',
    cat: '',
    subcat: '',
    metaKeywords: '',
    akamaiCacheBlockingImg:
      'https://static.toiimg.com/photo/msid-#MSID#/#MSID#.jpg',
    articledt: '',
    breadCrumb: 'News.Videos.News',
    pageType: isPodcast ? 'AUDIO' : 'VIDEO',
    audioMode,
    autoPlayAudio: false,

    //showNextButton: false,
  };
  if (sliketesting) {
    mainConfig.section = 'hlsads';
    //mainConfig.section = 'test';
  }
  if (testAds) {
    mainConfig.section = 'test';
  }
  /*

    *remvoe fn post Slike migration
    * check point, CMS INSERTED LIVE TV
    */
  TimesApps.convertMinutesToMs = function convertMinutesToMs(timeInMinutes) {
    let timeInMs = 0;
    if (typeof timeInMinutes !== 'undefined') {
      const timeSplit = timeInMinutes.toString().split(':');
      const SECONDS_IN_A_MINUTE = 60;
      const MS_IN_A_SECOND = 1000;

      if (timeSplit.length === 2) {
        timeInMs = timeSplit[0] * SECONDS_IN_A_MINUTE * MS_IN_A_SECOND;
        timeInMs += timeSplit[1] * MS_IN_A_SECOND;
      } else if (timeSplit.length === 1) {
        timeInMs = timeSplit[0] * SECONDS_IN_A_MINUTE * MS_IN_A_SECOND;
      }
    }

    return timeInMs;
  };

  TimesApps.AudioPlayerUtils = (function playerUtilClosure() {
    const config = {
      dataStorageKey: 'vodPLayer',
    };

    const constants = {
      seondsInOneMinute: 60,
      msInOneSecond: 1000,
    };

    const fn = {
      _getCookie(name) {
        const re = new RegExp(`${name}=([^;]+)`);
        const value = re.exec(document.cookie);
        return value !== null ? unescape(value[1]) : null;
      },
      _getData() {
        let data;
        try {
          data = JSON.parse(
            fn._getDataFromSessionStorage(config.dataStorageKey) || '{}',
          );
        } catch (e) {
          data = {};
        }
        return data;
      },
      _storeData(prop, value) {
        if (typeof prop === 'undefined' || prop.trim().length === 0) {
          return undefined;
        }

        const data = fn._getData();
        data[prop] = value;

        let dataJson;

        try {
          dataJson = JSON.stringify(data);
        } catch (e) {
          return false;
        }

        fn._setIntoSessionStorage(config.dataStorageKey, dataJson);
        return data;
      },
      _getDataFromSessionStorage(key) {
        let data;

        try {
          data = sessionStorage.getItem(key);
        } catch (e) {
          console.log('sessionStorage error', e);
        }

        return data;
      },
      _setIntoSessionStorage(key, value) {
        if (typeof key === 'undefined' || key.trim().length === 0) {
          return undefined;
        }

        try {
          sessionStorage.setItem(key, value);
        } catch (e) {
          console.log('sessionStorage error', e);
        }
        return undefined;
      },
      isTablet() {
        return (function returnAgent(agent) {
          return /(?:ipad|tab)/i.test(agent);
        })(navigator.userAgent || navigator.vendor || window.opera);
      },
      _getUserAgent() {
        return navigator.userAgent || navigator.vendor || window.opera;
      },
      _getVideoUrl() {
        let url = `${window.location.protocol}//${window.location.hostname}`;
        url += `/${mainConfig.seoLocation}`;
        url += '/videoshow/';
        url += `${mainConfig.msid}.cms`;
        return url;
      },
      _getVideoImg(bgImageString) {
        let bgImage = bgImageString || mainConfig.bgImage || '';
        const msid = mainConfig.msid || '';
        const imgReplaceMsidRegex = new RegExp('#MSID#', 'g');

        bgImage = bgImage.replace(imgReplaceMsidRegex, msid);

        return bgImage;
      },
      _fireVideoRequestGA() {
        const pubSub = TimesApps.PubSub;
        //fire VideoRequest GA
        const { playerName } = TimesApps.audioPlayer;
        const eventData = {};
        eventData.source = mainConfig.source;
        eventData.stream = 'CONTENT';
        eventData.userInitiated = mainConfig.userInitiated || '';
        eventData.id = mainConfig.msid || '';
        pubSub.publish(`${playerName}_EVENTS`, [
          eventData,
          isPodcast ? 'AUDIOREQUEST' : 'VIDEOREQUEST',
        ]);
        //console.log('PLAYER_EVENT....'+"VIDEOREQUEST isUserInitiated-"+eventData.userInitiated.toString());
      },
      _isParentWindowAccessAllowed() {
        const accessAllowed = true;
        try {
          //   const ifreamParent = window.parent.location.href;
        } catch (e) {
          console.log('cors error');
          //   accessAllowed = false;
        }

        return accessAllowed;
      },
      _sendDataToParentWindow(msgName, data) {
        if (!fn._isParentWindowAccessAllowed()) {
          return;
        }

        triggerEvent(msgName, data);
      },
      _isMute() {
        // let isMute = false;
        // /*
        // * moving to always mute first
        // * Deprecating..
        // */
        // //if( !isUserInitiated ){
        // isMute = true;
        // //}

        return false;
      },
      _checkGdprAndCall(callback, callbackForEu /*, checkForUserConsent*/) {
        try {
          window.TimesGDPR = window.parent.TimesGDPR;
        } catch (e) {
          console.log(e);
        }

        if (
          window.TimesGDPR &&
          window.TimesGDPR.common.consentModule.gdprCallback
        ) {
          window.TimesGDPR.common.consentModule.gdprCallback(data => {
            if (data && data.isEUuser && typeof callbackForEu === 'function') {
              callbackForEu();
            } else if (!data.isEUuser && typeof callback === 'function') {
              callback();
            }
          });
        } else if (typeof callbackForEu === 'function') {
          callbackForEu();
        }
      },
      _updateVolume(volume, isMute) {
        //TimesApps.Vod_Player.updateVolume
        const volumeData = {
          value: volume,
          isMute: !!isMute,
          updateTime: new Date().getTime(),
        };
        // console.log('storing volume', volumeData);
        TimesApps.AudioPlayerUtils.storeData('volume', volumeData);
      },
      _getVolume() {
        let volumeData = {
          volume: null,
          isMute: null,
        };
        const savedVolume = fn._getData().volume || {};
        const msIn30Mins =
          30 * constants.seondsInOneMinute * constants.msInOneSecond;
        if (
          typeof savedVolume === 'undefined' ||
          typeof savedVolume.value === 'undefined'
        ) {
          volumeData.volume = mainConfig.volume;
        } else if (new Date().getTime() + msIn30Mins < savedVolume.updateTime) {
          //volume was saved 30 back
          //expire volume
          //   volume = mainConfig.volume;
          TimesApps.AudioPlayerUtils.storeData('volume', {});
        } else {
          volumeData = {
            volumeLevel: savedVolume.value,
            isMute: savedVolume.isMute,
          };
        }
        return volumeData;
      },
    };

    const api = {
      isTablet() {
        return fn._isTablet();
      },
      getUserAgent() {
        return fn._getUserAgent();
      },
      getVideoUrl() {
        return fn._getVideoUrl();
      },
      getVideoImg(bgImageString) {
        return fn._getVideoImg(bgImageString);
      },
      // getAdsTargetParams() {
      //   return fn._getAdsTargetParams();
      // },
      fireVideoRequestGA() {
        return fn._fireVideoRequestGA();
      },
      isParentWindowAccessAllowed() {
        return fn._isParentWindowAccessAllowed();
      },
      sendDataToParentWindow(msgName, data) {
        return fn._sendDataToParentWindow(msgName, data);
      },
      getDataFromWebStorage(key) {
        return fn._getDataFromSessionStorage(key);
      },
      setIntoWebStorage(prop, value) {
        return fn._setIntoSessionStorage(prop, value);
      },
      getData() {
        return fn._getData();
      },
      storeData(prop, value) {
        return fn._storeData(prop, value);
      },
      isMute() {
        return fn._isMute();
      },
      checkGdprAndCall(callback, callbackForEu, checkForUserConsent) {
        return fn._checkGdprAndCall(
          callback,
          callbackForEu,
          checkForUserConsent,
        );
      },
      getCookie(name) {
        return fn._getCookie(name);
      },
      getVolume() {
        return fn._getVolume();
      },
      updateVolume(volume, isMute) {
        return fn._updateVolume(volume, isMute);
      },
    };

    return api;
  })();
  // /*
  //  * adding additional reference
  //  * deprecating TimesApps.AudioUtils
  //  * bcoz TimesApps.AudioUtils is also used by Video pages
  //  * & also inside player
  //  * & on live tv page player ( does not use iframe )
  //  */
  TimesApps.AudioUtils = TimesApps.AudioUtils || TimesApps.AudioPlayerUtils;
  // var TimesApps = window.TimesApps || {};
  /**
   * 'PubSub' module.
   *
   * @module PubSub
   */
  TimesApps.PubSub = (function createPubSub() {
    const mod_event = {};
    const pubsub = {};
    const onsubscribe_prefix = '__on_';
    const generateUid = (function generateUid() {
      let id = 0;
      return function incID() {
        id += 1;
        return id - 1;
      };
    })();
    /**
     * Publish subscribed events
     *
     * @param name Method name for the event to be published
     * @param data data to be passed to the subscribed event
     * @returns null
     */
    mod_event.publish = function publish(name, data) {
      if (!name) {
        return null;
      }
      if (pubsub[name]) {
        Object.keys(pubsub[name]).forEach(e => {
          const eventCallback = pubsub[name][e];
          try {
            //try catch done to keep publisher running in case of error in event callback
            eventCallback(data);
          } catch (err) {
            mod_event.publish('logger.error', err.stack);
          }
        });
      }
      return null;
    };
    mod_event.subscribeAll = function subscribeAll(
      name,
      eventCallback,
      options,
    ) {
      if (name instanceof Array) {
        const eventIds = [];
        let responses = [];
        const bindREsponse = response => {
          responses.push(response);
          if (eventIds.length === responses.length) {
            // todo fix, call even when first event is called twice
            if (eventCallback) {
              eventCallback(responses);
            }
            responses = [];
          }
        };
        for (let i = 0; i < name.length; i += 1) {
          eventIds.push(mod_event.subscribe(name[i], bindREsponse, options));
        }
        return eventIds;
      }
      return mod_event.subscribe(name, eventCallback, options);
    };
    //   /**
    //    * Subscribe custom events
    //    *
    //    * @param name Method name for the event to be subscribed
    //    * @param eventCallback(data) Function to be called when the event is published with the data
    //    * @options options
    //    * @returns eventId unique id generated for every subscription
    //    */
    mod_event.subscribe = function subscribe(name, eventCallback, options) {
      if (name instanceof Array) {
        const eventIds = [];
        for (let i = 0; i < name.length; i += 1) {
          eventIds.push(mod_event.subscribe(name[i], eventCallback, options));
        }
        return eventIds;
      }
      if (!name || !eventCallback) {
        return null;
      }
      if (!pubsub[name]) {
        pubsub[name] = {};
      }
      const eventId = `${name}:${generateUid()}`;
      pubsub[name][eventId] = eventCallback;
      //TODO find better way
      //Setting callback in options so that it can be used in onsubscribe event.
      const newOptions = options;
      if (options) {
        newOptions.__callback = eventCallback;
      }
      //Calling onsubscribe events
      mod_event.publish(onsubscribe_prefix + name, newOptions);
      return eventId;
    };
    //   /**
    //    * Unsubscribe an event
    //    *
    //    * @param eventId id of the event to be unsubscribed
    //    * @returns boolean true if event is successfully unsubscribed,else false
    //    */
    mod_event.unsubscribe = function unsubscribe(eventId) {
      if (!eventId) {
        return null;
      }
      const eventArr = eventId.split(':');
      if (eventArr.length === 2) {
        const eventName = eventArr[0];
        //            var eventNum = eventArr[1];
        if (pubsub[eventName][eventId]) {
          delete pubsub[eventName][eventId];
          return true;
        }
      }
      return false;
    };
    //   /**
    //    * Get all the subscribed events in an object
    //    *
    //    *
    //    * @param name Event name for which all events are required
    //    * @returns Event object for the provided event name
    //    */
    mod_event.getSubscriptions = function getSubscriptions(name) {
      if (!name) {
        return pubsub; //todo return cloned object istead of original
      }
      return pubsub[name];
    };
    //   /**
    //    * Used to subscribe to subscribe events, onsubscribe('method1') is called when subscribe('method1') is called
    //    * This can be used to setup data / setup publish events
    //    *
    //    * @param name
    //    * @param eventCallback
    //    * @returns {string}
    //    */
    mod_event.onsubscribe = function onsubscribe(name, eventCallback) {
      let newName = name;
      if (!newName || !eventCallback) {
        return null;
      }
      newName = onsubscribe_prefix + newName;
      if (!pubsub[newName]) {
        pubsub[newName] = {};
      }
      const eventId = `${newName}:${generateUid()}`;
      pubsub[newName][eventId] = eventCallback;
      return eventId;
    };
    return mod_event;
  })();

  TimesApps.loadJs = function loadJs(url, cb, nodeid) {
    const head = document.getElementsByTagName('head')[0];
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = url;
    s.async = true;
    s.id = nodeid || s.id;
    const ieCallback = function ieCallback(el, callback) {
      if (el.readyState === 'loaded' || el.readyState === 'complete') {
        callback();
      } else {
        setTimeout(() => {
          ieCallback(el, callback);
        }, 20);
      }
    };
    if (typeof cb === 'function') {
      if (typeof s.addEventListener !== 'undefined') {
        s.addEventListener('load', cb, false);
        s.addEventListener('error', cb, false);
      } else {
        s.onreadystatechange = function onreadystatechange() {
          s.onreadystatechange = null;
          ieCallback(s, cb);
        };
      }
    }
    head.appendChild(s);
  };

  TimesApps.FLAGS = {
    READY: 'READY',
    PLAYING: 'PLAYING',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    // AD_COMPLETED: 'AD_COMPLETED',
    REPLAY: 'REPLAY',
    NEXT_VIDEO: 'NEXT_VIDEO',
  };

  TimesApps.VideoPlayerAudio = (function createVideoPlayer2() {
    const defaultConfig = {};

    const data = {
      playerLoaded: false,
      playerState: undefined,
      videoMap: {},
    };
    const _setPlayerFlags = function _setPlayerFlags(dataObj) {
      if (!(dataObj instanceof Array) && !dataObj.length) {
        return;
      }
      // const eventData = dataObj[0] || {};
      const eventType = dataObj[1] ? dataObj[1].toUpperCase() : '';

      const { FLAGS } = TimesApps;

      switch (eventType) {
        case 'VIDEOREADY':
          data.playerState = FLAGS.READY;
          pauseOtherPlayers();
          break;
        case 'AUDIOREADY':
          data.playerState = FLAGS.READY;
          pauseOtherPlayers();
          break;
        case 'VIDEOVIEW':
          data.playerState = FLAGS.PLAYING;
          break;
        case 'AUDIOVIEW':
          data.playerState = FLAGS.PLAYING;
          break;
        case 'PAUSED':
          data.playerState = FLAGS.PAUSED;
          break;
        case 'VIDEOCOMPLETE':
          data.playerState = FLAGS.COMPLETED;
          break;
        case 'AUDIOCOMPLETE':
          data.playerState = FLAGS.COMPLETED;
          break;
        case 'START':
          data.playerState = FLAGS.PLAYING;
          pauseOtherPlayers();
          break;
        case 'RESUME':
          data.playerState = FLAGS.PLAYING;
          pauseOtherPlayers();
          break;
        // case 'ADCOMPLETE':
        //   data.playerState = FLAGS.AD_COMPLETED;
        //   break;
        case 'REPLAY':
          data.playerState = FLAGS.REPLAY;
          break;
        case 'ONNEXTVIDEOPLAY':
          data.playerState = FLAGS.NEXT_VIDEO;
          break;
        default:
        //case 'ADSKIP':
      }
    };
    const bindPlayerEvents = function bindPlayerEvents() {
      const pubSub = TimesApps.PubSub;
      pubSub.subscribe('VOD_EVENTS', _setPlayerFlags);
    };
    const fn = {
      _init() {
        fn._loadAssets();
        bindPlayerEvents();
      },
      _loadAssets() {
        const playerJs = document.createElement('script');
        /*changing slike sdk for slike testing, please compare version with toi HP*/

        playerJs.src = `//tvid.in/sdk/slikeloader.js`;

        if (asyncLoadSdkjs) {
          playerJs.async = true;
          playerJs.defer = true;
        }
        /*
        if (sliketesting) {
          playerJs.src = '//videoplayer.indiatimes.com/v2.4/sdk.js';
        }
        */
        // const scriptTag = document.getElementsByTagName('script')[0];

        const slikeJsOnloadCB = function slikeJsOnloadCB(event) {
          data.playerLoaded = true;
          /*if(typeof require !="undefined"){
                      var pubSub = require("tiljs/event");
                  }else{
                      var pubSub = TimesApps.PubSub;
                  }*/
          const pubSub = TimesApps.PubSub;
          pubSub.publish('slikeLoaded');

          //for GA
          const { playerName } = TimesApps.audioPlayer;
          const eventData = {};
          eventData.source = mainConfig.source;
          eventData.loadStatus = (event && event.type) || '';
          eventData.stream = 'CONTENT';
          eventData.userInitiated = mainConfig.userInitiated || '';
          eventData.id = mainConfig.msid || '';
          pubSub.publish(`${playerName}_EVENTS`, [
            eventData,
            'slikeLoaded'.toUpperCase(),
          ]);
        };

        // const slikePlayerJSLoad = () => {
        //   TimesApps.loadJs(playerJs.src, slikeJsOnloadCB, '');
        // };
        if (
          typeof window.player === 'object' &&
          (typeof window.player.load === 'function' ||
            (window.player.length > 0 &&
              window.player[window.player.length - 1].load === 'function'))
        ) {
          slikeJsOnloadCB();
        } else {
          loadPlayerJSFiles(slikeJsOnloadCB);
          // TimesApps.loadJs(
          //   '//imasdk.googleapis.com/js/sdkloader/ima3.js',
          //   slikePlayerJSLoad,
          //   'ima3_sdk_js',
          // );
        }
      },
      _addVideo(domSelector, config, playerId) {
        if (!data.playerLoaded) {
          return;
        }

        (function publishVideoLoadRequest() {
          const pubSub = TimesApps.PubSub;
          const { playerName } = TimesApps.audioPlayer;
          const eventData = {};
          eventData.source = mainConfig.source;
          eventData.stream = 'CONTENT';
          eventData.userInitiated = mainConfig.userInitiated || '';
          eventData.id = mainConfig.msid || '';
          pubSub.publish(`${playerName}_EVENTS`, [
            eventData,
            'VIDEOLOADREQUEST',
          ]);
        })();

        //TimesApps.SlikeTrackerPixels('BEFORE_S_LOAD');
        const handlePlayerEvents = player => {
          function eventToFunction(playerData, eventName, eventData) {
            console.log(eventName);
            const funcName = eventName.replace('spl', 'on');
            const updatedEventData = Object.assign(
              {},
              eventData,
              playerData.store.video,
            );
            const playerEvents = TimesApps.audioPlayerCallbacks;
            if (playerEvents && typeof playerEvents[funcName] === 'function') {
              let eventCallback = () => {};
              if (
                typeof eventsCallbackMap === 'object' &&
                typeof eventsCallbackMap[funcName] === 'function'
              ) {
                eventCallback = eventsCallbackMap[funcName];
              }
              playerEvents[funcName](
                updatedEventData,
                playerData,
                funcName,
                eventCallback,
              );
            }
          }
          Object.keys(window.SlikePlayer.Events).forEach(eventKey => {
            const eventName = window.SlikePlayer.Events[eventKey];
            player.on(eventName, eventToFunction.bind(null, player));
          });
        };
        const slikePlayerCallback = (status, inst) => {
          //player is lnitialized now...
          if (status && intantiateNewPlayer) {
            if (window.location.href.indexOf('/articleshow/') > -1) {
              if (window.player?.length) {
                window.player[window.player.length] = new window.SlikePlayer(
                  inst,
                );
              } else {
                window.player = [];
                window.player[0] = new window.SlikePlayer(inst);
              }
            } else {
              window.player = new window.SlikePlayer(inst);
            }
            // handleAdEvents(window.player);
          }

          // eslint-disable-next-line no-param-reassign
          // config.player.msid = msid || config.player.msid;

          const playerInst =
            window.player?.length > 0
              ? window.player[window.player?.length - 1]
              : window.player;

          handlePlayerEvents(playerInst);
          // handleAdEvents(playerInst);
          //const { player } = window;
          data.videoMap[playerId] = playerInst;

          //trigger video loaded
          const pubSub = TimesApps.PubSub;
          const eventData = {};
          //eventData.source = TimesApps.audioPlayer.playerName;
          eventData.domSelector = domSelector;
          eventData.source = mainConfig.source;
          eventData.userInitiated = mainConfig.userInitiated || '';
          eventData.stream = 'CONTENT';
          eventData.id = mainConfig.msid || '';
          pubSub.publish('slikeVideoLoaded', [eventData]);
          if (callbackOutside) {
            callbackOutside(inst);
          }
          (function publishVideoPlayerCreated() {
            // const pubSub = TimesApps.PubSub;
            const { playerName } = TimesApps.audioPlayer;
            pubSub.publish(`${playerName}_EVENTS`, [
              eventData,
              'VIDEOPLAYERCREATED',
            ]);
          })();
          // TimesApps.SlikeTrackerPixels('AFTER_S_LOAD');
        };
        function callWindowSLoad() {
          // eslint-disable-next-line func-names
          const callsloadfn = function() {
            // if (!window.slikesdkloadedcompletely) {
            //   setTimeout(callsloadfn, 30);
            // } else {
            //   try {
            //     window.S.load(domSelector, config, slikePlayerCallback);
            //   } catch (err) {
            //     //console.llog(err)
            //   }
            // }
            config.player = {
              ...config?.player,
              contWidth: document.getElementById(domSelector)?.offsetWidth || 0,
              contHeight:
                document.getElementById(domSelector)?.offsetHeight || 0,
            };

            const PLAYER_CONFIG = {
              ...config,
              contEl: domSelector,
            };
            if (
              (intantiateNewPlayer || !typeof window.player === 'object') &&
              window.spl &&
              window.spl.load
            ) {
              window.spl.load(PLAYER_CONFIG, slikePlayerCallback);
            } else {
              // window.TimesApps.slikePlayerCallback();
              // window.player.load(PLAYER_CONFIG);
              const plyInst =
                typeof window.player === 'object' && window.player.length > 0
                  ? window.player[window.player.length - 1]
                  : window.player;
              plyInst.load({
                id: config.player.id,
                playerType: config.player.playerType || '',
                msid: config.player.msid,
              });
            }
          };
          callsloadfn();
        }
        try {
          callWindowSLoad();
          //window.S.load(domSelector, config, slikePlayerCallback);
        } catch (err) {
          // window.S.load(domSelector, config, slikePlayerCallback);
        }
      },
      _getVideo(playerId) {
        let videoPlayer;
        if (window.player === 'object') {
          //videoPlayer = window.player;
          videoPlayer =
            window.player.length > 0
              ? window.player[window.player.length - 1]
              : window.player;
        } else {
          videoPlayer = data.videoMap[playerId];
        }

        return videoPlayer;
      },
      _pause(playerId) {
        /*
         *temporary hack
         *issue with slike
         *reference is broken
         *points to old instance
         */
        let player;
        const playerName = playerId
          ? this.playerName
          : TimesApps.audioPlayer.playerName;
        if (typeof window.player === 'object') {
          //player = window.player;
          player =
            window.player.length > 0
              ? window.player[window.player.length - 1]
              : window.player;
        } else {
          player = fn._getVideo(playerName);
        }

        if (TimesApps.isDevMode) {
          console.log(`${'VOD_status_pausing__'}${playerId}`);
        }
        player.pause();
      },
      _play(playerId) {
        const player = fn._getVideo(playerId);
        player.play();
      },
      _setNextVideo(nextVideoObject, playerId) {
        //const player = fn._getVideo(playerId) || window.player;
        const player =
          fn._getVideo(playerId) ||
          (window.player.length > 0
            ? window.player[window.player.length - 1]
            : window.player);
        player.setNextItem(nextVideoObject);
      },
      _setCurrentVideoInPlaylist(nextVideoObject, playerId) {
        //const player = fn._getVideo(playerId) || window.player;
        const player =
          fn._getVideo(playerId) ||
          (window.player.length > 0
            ? window.player[window.player.length - 1]
            : window.player);
        player.setCurVideoItem(nextVideoObject);
      },
      _getPlayerState() {
        return data.playerState;
      },
    };

    const api = {
      init() {
        fn._init();
      },
      addPlayer(domSelector, config, playerId) {
        fn._addVideo(domSelector, config, playerId);
      },
      getPlayer(playerId) {
        return fn._getVideo(playerId);
      },
      getConfig() {
        return defaultConfig;
      },
      isSlikeLoaded() {
        return data.playerLoaded;
      },
      pause(playerId) {
        fn._pause(playerId);
      },
      play(playerId) {
        fn._play(playerId);
      },
      setNextVideo(nextVideoObject, playerId) {
        fn._setNextVideo(nextVideoObject, playerId);
      },
      setCurrentVideoInPlaylist(nextVideoObject, playerId) {
        fn._setCurrentVideoInPlaylist(nextVideoObject, playerId);
      },
      getPlayerState() {
        return fn._getPlayerState();
      },
    };

    return api;
  })();

  // /*callbacks for video events*/
  TimesApps.audioPlayerCallbacks = {
    onInit(eventData, playerData) {
      const { playerName } = TimesApps.audioPlayer;
      const newEventData = playerData || {} || eventData;
      newEventData.source = mainConfig.source;
      newEventData.stream = 'CONTENT';
      newEventData.userInitiated = mainConfig.userInitiated || '';
      newEventData.id = mainConfig.msid || '';
      const eventType = 'VIDEOINIT';
      //console.log('PLAYER_EVENT....'+eventType);
      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [newEventData, eventType]);

      //triggerEvent(playerName+'_EVENTS', [eventData, eventType]);
    },
    onReady(eventData, playerData = {}) {
      const { playerName } = TimesApps.audioPlayer;
      let newEventData = playerData || eventData || {};
      if (typeof newEventData !== 'object') {
        newEventData = {};
      }
      newEventData.source = mainConfig.source;
      newEventData.stream = 'CONTENT';
      newEventData.userInitiated = mainConfig.userInitiated || '';
      newEventData.id = mainConfig.msid || '';
      const eventType = 'VIDEOREADY';
      //console.log('PLAYER_EVENT....'+eventType);
      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [newEventData, eventType]);
      triggerEvent(`${playerName}_EVENTS`, [
        newEventData,
        eventType,
        playerData.id || '',
      ]);
    },
    onVideoStarted(playerData, event, eventName, eventCallback) {
      if (event?.store?.clientConfig?.contEl) {
        holdOtherPlayers(event.store.clientConfig.contEl);
      }
      const pubSub = TimesApps.PubSub;
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      eventData.userInitiated = mainConfig.userInitiated || '';
      let eventType = 'START';
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);
      // const pageType = TimesApps.pagetype || '';
      if (isPodcast) {
        eventType = 'AUDIOVIEW';
      } else {
        eventType = 'VIDEOVIEW';
      }
      if (typeof addToWatched === 'function') {
        addToWatched(mainConfig.msid);
      }
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);
      if (typeof eventCallback === 'function') {
        eventCallback(eventType, eventData);
      }
    },
    onVideoResumed(playerData, event, eventName, eventCallback) {
      //trigger event for pause
      if (event?.store?.clientConfig?.contEl) {
        holdOtherPlayers(event.store.clientConfig.contEl);
      }
      const eventData = playerData || {};
      const { playerName } = TimesApps.audioPlayer;
      eventData.userInitiated = mainConfig.userInitiated || '';
      eventData.source = mainConfig.source;
      const newEventType = 'PLAYING';

      if (TimesApps.isDevMode) {
        console.log(`VOD_status_${eventData.source}__${newEventType}`);
      }
      triggerEvent(`${playerName}_EVENTS`, [eventData, newEventType]);

      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, newEventType]);
      if (typeof eventCallback === 'function') {
        eventCallback(newEventType, eventData);
      }
    },
    onVideoPaused(playerData, event, eventName, eventCallback) {
      //trigger event for pause
      const eventData = playerData || {};
      const { playerName } = TimesApps.audioPlayer;
      eventData.userInitiated = mainConfig.userInitiated || '';
      eventData.source = mainConfig.source;
      const newEventType = 'PAUSED';

      if (TimesApps.isDevMode) {
        console.log(`VOD_status_${eventData.source}__${newEventType}`);
      }
      triggerEvent(`${playerName}_EVENTS`, [eventData, newEventType]);

      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, newEventType]);
      if (typeof eventCallback === 'function') {
        eventCallback(newEventType, eventData);
      }
    },
    /*onVideoStarted(eventType, playerData, eventCallback) {
      //trigger event for play
      const eventData = playerData || {};
      const { playerName } = TimesApps.audioPlayer;
      eventData.userInitiated = mainConfig.userInitiated || '';
      eventData.source = mainConfig.source;
      const newEventType = 'PLAYING';

      if (TimesApps.isDevMode) {
        console.log(`VOD_status_${eventData.source}__${newEventType}`);
      }
      triggerEvent(`${playerName}_EVENTS`, [eventData, newEventType]);

      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, newEventType]);
      if (typeof eventCallback === 'function') {
        eventCallback(newEventType, eventData);
      }
    },*/
    onVideoFullscreenchange(playerData, event, eventName) {
      const eventData = playerData || {};
      const { playerName } = TimesApps.audioPlayer;
      eventData.source = mainConfig.source;
      eventData.userInitiated = mainConfig.userInitiated || '';
      let newEventType = eventName;
      newEventType = newEventType === true ? 'FULLSCREEN_ON' : 'FULLSCREEN_OFF';
      const pubSub = TimesApps.PubSub;
      if (newEventType === 'FULLSCREEN_ON') {
        pubSub.publish(`${playerName}_EVENTS`, [eventData, newEventType]);
      }
    },
    onAdEvent(eventName, data) {
      //trigger event for pause
      const adData = data && data instanceof Array ? data[0] : {};
      const playerData =
        data && data instanceof Array && data[1] ? data[1] : {};
      const eventData = playerData || {};
      eventData.stream = 'AD';
      eventData.adtype = adData.adtype;
      const { playerName } = TimesApps.audioPlayer;
      eventData.source = mainConfig.source;
      eventData.userInitiated = mainConfig.userInitiated || '';
      eventData.adErrorcode = adData.errorcode || '';
      eventData.campaignId = adData.campaignId || '';
      eventData.isHls = adData.isHls || false;
      let eventType = adData.state ? adData.state.toUpperCase() : '';
      const pubSub = TimesApps.PubSub;
      if (
        eventType === 'START' ||
        eventType === 'PAUSED' ||
        eventType === 'COMPLETE'
      ) {
        if (eventType === 'START') {
          eventType = 'ADVIEW';
        } else if (eventType === 'COMPLETE') {
          eventType = 'ADCOMPLETE';
        }
      } else if (eventType === 'SKIP') {
        eventType = 'ADSKIP';
      } else if (eventType === 'REQUEST') {
        eventType = 'ADREQUEST';
      } else if (eventType === 'LOADED') {
        eventType = 'AdLoaded';
      }
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);

      if (
        eventType === 'PLAYING' ||
        eventType === 'PAUSED' ||
        eventType === 'RESUME'
      ) {
        if (eventType === 'RESUME') {
          eventType = 'PLAYING';
        }
        if (TimesApps.isDevMode) {
          console.log(`VOD_status_ADS_${eventData.source}__${eventType}`);
        }
        //publish to iframe parent
        eventType =
          eventType === 'PLAYING' || eventType === 'START'
            ? 'PLAYING'
            : eventType;
        // triggerEvent(`${playerName}_EVENTS`, [eventData, eventType]);
      }
      triggerEvent(`${playerName}_EVENTS`, [eventData, eventType]);
      const VIDEO_AD_SKIP_Event = new CustomEvent('VIDEO_EVENTS', {
        detail: eventType,
      });
      window.dispatchEvent(VIDEO_AD_SKIP_Event);
    },
    onVideoEnded(adData, playerData) {
      //called when video ends...
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      eventData.userInitiated = mainConfig.userInitiated || '';
      const eventType = 'VIDEOCOMPLETE';

      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);

      if (
        TimesApps.AudioPlayerUtils &&
        TimesApps.AudioPlayerUtils.sendDataToParentWindow
      ) {
        TimesApps.AudioUtils.sendDataToParentWindow(`${playerName}_EVENTS`, [
          eventData,
          eventType,
        ]);
      }
    },
    onEndScreenAutoPlay(nextVideoData) {
      //called when next video is autoplayed
      const { playerName } = TimesApps.audioPlayer;
      const eventData = nextVideoData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      //empty string resolves to false
      mainConfig.userInitiated = '';
      eventData.userInitiated = mainConfig.userInitiated || '';

      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);

      triggerEvent(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);
    },
    onEndScreenNextClick(nextVideoData) {
      //called when user clicks to play next video
      const pubSub = TimesApps.PubSub;
      const { playerName } = TimesApps.audioPlayer;
      const eventData = nextVideoData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      eventData.userInitiated = true;

      pubSub.publish(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);

      triggerEvent(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);
    },
    onEndScreenReplay(adData, playerData) {
      //called, when replay is clicked
      const pubSub = TimesApps.PubSub;
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      eventData.userInitiated = true;

      pubSub.publish(`${playerName}_EVENTS`, [eventData, 'REPLAY']);
      pubSub.publish(`${playerName}_EVENTS`, [
        eventData,
        isPodcast ? 'AUDIOREQUEST' : 'VIDEOREQUEST',
      ]);
      //console.log('PLAYER_EVENT....'+eventType);
      if (TimesApps.isDevMode) {
        console.log(':::::onEndScreenReplay::::', adData, playerData);
      }
    },
    onEndScreenPlay(nextVideoData) {
      //called when user clicks
      //bottom right ribbon to play next video
      if (TimesApps.isDevMode) {
        console.log(':::::onEndScreenPlay::::', nextVideoData);
      }
      const pubSub = TimesApps.PubSub;
      const { playerName } = TimesApps.audioPlayer;
      const eventData = nextVideoData || {};
      eventData.source = mainConfig.source;
      eventData.stream = 'CONTENT';
      eventData.userInitiated = true;

      pubSub.publish(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);

      triggerEvent(`${playerName}_EVENTS`, [eventData, 'onNextVideoPlay']);
    },
    onDimClick(isAlreadyDim, playerData) {
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.userInitiated = mainConfig.userInitiated || '';
      eventData.isAlreadyDim = isAlreadyDim;
      const eventType = 'DIM_TOGGLE';
      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);

      if (
        TimesApps.AudioPlayerUtils &&
        TimesApps.AudioPlayerUtils.sendDataToParentWindow
      ) {
        TimesApps.AudioPlayerUtils.sendDataToParentWindow(
          `${playerName}_EVENTS`,
          [eventData, eventType],
        );
      }
    },
    onAutoPlayClick(adData, playerData) {
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.userInitiated = mainConfig.userInitiated || '';
      const eventType = isPodcast
        ? 'AUDIOAUTOPLAY_TOGGLE'
        : 'VIDEOAUTOPLAY_TOGGLE';
      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);
    },
    onVolumeChange(volumeChange, playerData, eventName, eventCallback) {
      const { playerName } = TimesApps.audioPlayer;
      const eventData = playerData || {};
      eventData.source = mainConfig.source;
      eventData.userInitiated = mainConfig.userInitiated || '';

      const eventType = 'OnVolumeChange';
      const pubSub = TimesApps.PubSub;
      pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);
      if (typeof eventCallback === 'function') {
        eventCallback(volumeChange);
      }
    },
    onHeaderReady(eventData) {
      const { playerName } = TimesApps.audioPlayer;
      const newEventData = eventData || {};
      newEventData.source = mainConfig.source;
      newEventData.userInitiated = mainConfig.userInitiated || '';

      const eventType = 'onHeaderReady';
      // var pubSub = TimesApps.PubSub;
      // pubSub.publish(playerName+'_EVENTS', [newEventData, eventType]);

      if (
        TimesApps.AudioPlayerUtils &&
        TimesApps.AudioPlayerUtils.sendDataToParentWindow
      ) {
        TimesApps.AudioPlayerUtils.sendDataToParentWindow(
          `${playerName}_EVENTS`,
          [newEventData, eventType],
        );
      }
    },
  };

  // TimesApps.SlikeTrackerPixelsData = {
  //   css: null,
  // };
  // TimesApps.SlikeTrackerPixels = function SlikeTrackerPixels(type) {
  //   // const config = {};
  //   const id = mainConfig.mediaId;
  //   const pn = mainConfig.site; //Your Property short name here in 3 characters
  //   const apikey = mainConfig.slikeApiKey; //YOUR_APIKEY_HERE
  //   let OSName = 'Unknown OS';
  //   let css;
  //   let param;
  //   let rn;
  //   if (navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
  //   if (navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';
  //   if (navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
  //   if (navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux';
  //   const osn = OSName; //OS NAME HERE
  //   const uan = navigator.userAgent; //UA NAME HERE
  //   const templateName = mainConfig.source; //TEMPLATE NAME HERE
  //   const ets = new Date().getTime();
  //   if (type === 'BEFORE_S_LOAD') {
  //     rn = 0 + Math.floor(Math.random() * 899999) + 1e5;
  //     css = `${id}.${pn}.${ets}.${rn}`;
  //     TimesApps.SlikeTrackerPixelsData.css = css;
  //     param = `res=pix&type=sdk&at=-4&apikey=${apikey}&ven=${pn}&k=${id}&css=${css}&osn=${osn}&uan=${uan}tpl${templateName}&ets=${ets}`;
  //   } else {
  //     css = TimesApps.SlikeTrackerPixelsData.css;
  //     param = `res=pix&type=sdk&at=-1&apikey=${apikey}&ven=${pn}&k=${id}&css=${css}&osn=${osn}&uan=${uan}tpl${templateName}&ets=${ets}`;
  //   }

  //   const prodUrl = 'https://slike.indiatimes.com/savelogs?';
  //   const baseurl = prodUrl;
  //   new Image().src = baseurl + param;
  // };

  TimesApps.ComscoreConfig = TimesApps.ComscoreConfig || {};

  if (TimesApps.AudioUtils.checkGdprAndCall) {
    TimesApps.AudioUtils.checkGdprAndCall(
      null,
      () => {
        TimesApps.ComscoreConfig.cs_ucfr = 0;
      },
      false,
    );
  }

  // //flag to check if next video has been played by the player
  // //used in case of videoshow and videolist
  TimesApps.playingSubsequentVideo = false;

  TimesApps.videoEventsMap = {
    START: 'START',
    //"PLAYING"        : "PLAYING",
    STOP: 'STOP',
    //"VIDEOCOMPLETE"  : "VIDEOCOMPLETE",
    PAUSED: 'PAUSED',
    //"ADVIEW"         : "ADVIEW",
    ADCOMPLETE: 'ADCOMPLETE',
  };

  // /*
  //  *remvoe fn post Slike migration
  //  * check point, CMS INSERTED LIVE TV
  //  */
  const convertMinutesToMs = function convertMinutesToMs(timeInMinutes) {
    let timeInMs = 0;
    if (typeof timeInMinutes !== 'undefined') {
      const timeSplit = timeInMinutes.toString().split(':');
      const SECONDS_IN_A_MINUTE = 60;
      const MS_IN_A_SECOND = 1000;

      if (timeSplit.length === 2) {
        timeInMs = timeSplit[0] * SECONDS_IN_A_MINUTE * MS_IN_A_SECOND;
        timeInMs += timeSplit[1] * MS_IN_A_SECOND;
      } else if (timeSplit.length === 1) {
        timeInMs = timeSplit[0] * SECONDS_IN_A_MINUTE * MS_IN_A_SECOND;
      }
    }

    return timeInMs;
  };

  // /*
  //     currently moved to vod_player_js
  //     remove after moving to Utils for vod, live, minitv
  // */
  TimesApps.convertMinutesToMs =
    TimesApps.convertMinutesToMs || convertMinutesToMs;

  const fireComscoreTrackingRequest = function fireComscoreTrackingRequest(
    comscoreCustomerId,
    eventType,
    contentType,
    stationTitle,
    publisherName,
    trackingDetails,
    videoObj,
  ) {
    const { ns_ } = window;
    if (
      typeof window.myStreamingTag === 'undefined' ||
      eventType === 'REPLAY'
    ) {
      window.myStreamingTag = new ns_.StreamingTag({
        customerC2: comscoreCustomerId,
      });
    }

    if (typeof TimesApps.videoEventsMap[eventType] === 'undefined') {
      //event is not in list of events to track
      return;
    }

    if (
      typeof comscoreCustomerId === 'undefined' ||
      comscoreCustomerId === ''
    ) {
      return;
    }
    let newContentType = contentType;
    if (TimesApps.isServingAdInFlashPlayer) {
      newContentType = 'AD';
    }

    try {
      if (
        eventType === 'START' ||
        eventType === 'PLAYING' ||
        eventType === 'ADVIEW'
      ) {
        let seoLocation = trackingDetails.seoLocation.split('/');
        if (seoLocation.length >= 2) {
          const seoLocationWithoutTitle = seoLocation.length - 1;
          seoLocation = seoLocation.slice(0, seoLocationWithoutTitle).join('/');
        } else {
          seoLocation = trackingDetails.seoLocation;
        }
        const videoDuration = TimesApps.convertMinutesToMs(videoObj.duration);
        const metd = {
          ns_st_ci: videoObj.id || videoObj.videoid || 0,
          ns_st_cl: videoDuration || 0,
          ns_st_st: stationTitle,
          ns_st_pu: publisherName,
          ns_st_pr: seoLocation,
          ns_st_ep: videoObj.title,
          ns_st_sn: '*null',
          ns_st_en: '*null',
          ns_st_ge: trackingDetails.contentGenre,
          ns_st_ti: '*null',
          ns_st_ia: '0',
          ns_st_ce: '0',
          ns_st_ddt: trackingDetails.airDate,
          ns_st_tdt: trackingDetails.airDate,
          c3: trackingDetails.c3 || '*null',
          c4: '*null',
          c6: '*null',
        };
        if (TimesApps.ComscoreConfig.cs_ucfr === 0) {
          metd.cs_ucfr = TimesApps.ComscoreConfig.cs_ucfr;
        }
        window.myStreamingTag.playVideoContentPart(
          metd,
          ns_.StreamingTag.ContentType.ShortFormOnDemand,
        );
      } else if (!(newContentType === 'AD' && eventType !== 'ADCOMPLETE')) {
        //STOP, VIDEOCOMPLETE, PAUSED
        window.myStreamingTag.stop();
      }
    } catch (e) {
      console.log(e);
    }
  };

  if (TimesApps.AudioUtils && TimesApps.AudioUtils.checkGdprAndCall) {
    TimesApps.AudioUtils.checkGdprAndCall(null, () => {
      analyticsWrapper('gaAndGrx', 'set', 'anonymizeIp', true);
    });
  }

  TimesApps.sourceToLocationMapping = {
    // MG_0: 'Homepage/topvideoswidget',
    // MG: 'Homepage/trendingvideoswidget',
    // ABOVEARTICLE: 'articleshow/lead',
    // ARTICLEEMBED: 'articleshow/inline',
    // 'ARTICLESHOW/NIC': 'articleshow/nic',
    // 'ARTICLESHOW/RELATED': 'articleshow/related',
    // VIDEOSHOW: 'videoshow',
    // DAILYBRIEF: 'dailybrief',
    // VIDEOSHOME: 'videoshome',
    // MINI_TV: 'minitv',
    // MG_LIVE_TV: 'livetvplugbottomright',
    // LIVEHOME_LIVE_TV: 'livetvhome',
    // 'HOMEPAGE/LIVETVWIDGET': 'Homepage/livetvwidget',
    // LIVEBLOG: 'liveblog',
    // CMS_INSERTED_LIVE_TV: 'liveblog',
    // CITYLANDINGPAGE: 'articlelist/city',
    // CITYSPECIFIC: 'articlelist/city',
    // SPORTS: 'articlelist/sports',
  };

  TimesApps.VideosGa = (function VideosGa() {
    // var fn, api, config;

    const config = {
      adErrorCodes: {
        101: 'VAST_SCHEMA_VALIDATION_ERROR',
        102: 'VAST_UNSUPPORTED_VERSION',
        200: 'VAST_TRAFFICKING_ERROR',
        201: 'VAST_UNEXPECTED_LINEARITY',
        202: 'VAST_UNEXPECTED_DURATION_ERROR',
        300: 'VAST_WRAPPER_ERROR',
        301: 'VAST_LOAD_TIMEOUT',
        302: 'VAST_TOO_MANY_REDIRECTS',
        303: 'VAST_NO_ADS_AFTER_WRAPPER',
        400: 'VIDEO_PLAY_ERROR',
        402: 'VAST_MEDIA_LOAD_TIMEOUT',
        403: 'VAST_LINEAR_ASSET_MISMATCH',
        500: 'OVERLAY_AD_PLAYING_FAILED',
        501: 'NONLINEAR_DIMENSIONS_ERROR',
        503: 'VAST_NONLINEAR_ASSET_MISMATCH',
        602: 'COMPANION_REQUIRED_ERROR',
        900: 'UNKNOWN_ERROR',
        1005: 'FAILED_TO_REQUEST_ADS',
        1007: 'VAST_ASSET_NOT_FOUND',
        1009: 'VAST_EMPTY_RESPONSE',
        1010: 'UNKNOWN_AD_RESPONSE',
        1011: 'UNSUPPORTED_LOCALE',
        1101: 'INVALID_ARGUMENTS',
        1105: 'INVALID_ADX_EXTENSION',
      },
    };

    const fn = {
      _getErrorLabelFromCode(errorCode) {
        return config.adErrorCodes[errorCode] || '';
      },
    };

    const api = {
      getErrorLabelFromCode(errorCode) {
        return fn._getErrorLabelFromCode(errorCode);
      },
    };

    return api;
  })();

  TimesApps.prepareDataForGA = function prepareDataForGA(
    event,
    eventData,
    eventType,
  ) {
    const videoId = eventData.source ? eventData.source.toUpperCase() : '';

    const newEventType = eventType ? eventType.toUpperCase() : '';
    let timeTakenToVideoReady;
    if (newEventType === 'VIDEOREQUEST' || newEventType === 'AUDIOREQUEST') {
      TimesApps.videoRequestTime = Date.now();
    } else if (newEventType === 'VIDEOREADY' || newEventType === 'AUDIOREADY') {
      timeTakenToVideoReady = Date.now() - TimesApps.videoRequestTime;
    }

    let isAutoplayOn = false;
    const pageName = mainConfig.pageName || '';

    if (
      pageName === 'HP' &&
      typeof window.parentparent.TimesApps !== 'undefined' &&
      typeof window.parent.TimesApps.VideoGalleryApp !== 'undefined' &&
      videoId === 'MG_0'
    ) {
      //taking status from VideoGalleryApp
      const videoList = window.parent.TimesApps.VideoGalleryApp.getVideoList();
      const video = videoList[videoId];

      if (typeof video !== 'undefined') {
        // const domEle = video.domEle;
        isAutoplayOn = video.config.autoplay;
      }
    } else if (
      TimesApps.playingSubsequentVideo &&
      eventData.userInitiated !== '' &&
      !eventData.userInitiated
    ) {
      isAutoplayOn = true;
    } else if (
      eventData.userInitiated === '0' ||
      eventData.userInitiated === ''
    ) {
      isAutoplayOn = true;
    }
    let seoLocation = '';
    const videoLocationOnPage =
      TimesApps.sourceToLocationMapping[videoId] || eventData.source;
    if (!TimesApps.Vod_Player && TimesApps.playingSubsequentVideo) {
      //next video is triggerd from withing player
      // nextVideoObj = TimesApps.nextVideoObj;
      // var seoLocation = nextVideoObj.seopath;
    } else {
      // var seoLocation = '' || '';
      seoLocation = seoLocation.trim();
      seoLocation =
        seoLocation.length > 0 ? seoLocation : mainConfig.seoLocation;
    }

    //when no agency, passing blank to help
    //debug in GA
    const agency = mainConfig.agency || 'blank';

    TimesApps.fireGAevents(
      eventData,
      newEventType,
      isAutoplayOn,
      seoLocation,
      videoLocationOnPage,
      agency,
      timeTakenToVideoReady,
    );
  };

  TimesApps.fireGAevents = function fireGAevents(
    eventData,
    eventType,
    isAutoplayOn,
    seoLocation,
    videoLocationOnPage,
    agency,
    timeTakenToVideoReady,
  ) {
    const videoEventsMap = [
      'VIDEOREQUEST',
      'VIDEOREADY',
      'VIDEOVIEW',
      'VIDEOCOMPLETE',
      'VIDEOAUTOPLAY_TOGGLE',
      'AUDIOREQUEST',
      'AUDIOREADY',
      'AUDIOVIEW',
      'AUDIOCOMPLETE',
      'AUDIOAUTOPLAY_TOGGLE',
      'PLAYING',
      'PAUSED',
      // 'ADREQUEST',
      // 'ADLOADED',
      // 'ADCOMPLETE',
      // 'ADSKIP',
      // 'ADVIEW',
      'AUDIOPLAY',
      'FULLSCREEN_ON',
      'DIM_TOGGLE',
      'ERROR',
    ];

    const ga = window?.ga || window?.parent?.ga;

    if (typeof ga === 'undefined') {
      return;
    }

    if (videoEventsMap.indexOf(eventType) === -1) {
      //event is not in list of events to track
      return;
    }

    // eslint-disable-next-line no-unused-vars
    let eventAction = '';
    let eventCat = eventType;

    if (timeTakenToVideoReady) {
      eventAction += `${timeTakenToVideoReady}ms_`;
    }
    const stxt = eventData.stxt ? eventData.stxt.toUpperCase() : '';
    let currentVideoURL = '';
    if (
      mainConfig.nextVideoURL &&
      !(eventType === 'VIDEOCOMPLETE' || eventType === 'AUDIOCOMPLETE')
    ) {
      currentVideoURL = mainConfig.nextVideoURL.includes('videosvideos')
        ? mainConfig.nextVideoURL.replace('/videosvideos', 'videos')
        : mainConfig.nextVideoURL;
    } else {
      currentVideoURL = `${seoLocation}/videoshow/${mainConfig.msid}.cms`;
    }
    switch (eventType) {
      case 'VIDEOAUTOPLAY_TOGGLE':
        //autoplay setting toggle event
        eventAction += stxt === 'OFF' ? 'Enable' : 'Disable';
        break;
      case 'AUDIOAUTOPLAY_TOGGLE':
        //autoplay setting toggle event
        eventAction += stxt === 'OFF' ? 'Enable' : 'Disable';
        break;
      case 'FULLSCREEN_ON':
        eventCat = 'FULLSCREEN_ON';
        eventAction += `/${seoLocation}`;
        break;
      case 'DIM_TOGGLE':
        eventCat = 'VideoPlayer';
        eventAction += `${'Dim/'}${seoLocation}`;
        break;
      case 'ERROR':
        eventCat = 'AdError';
        eventAction = TimesApps.VideosGa.getErrorLabelFromCode(
          eventData.adErrorcode,
        );
        eventAction += `/${eventData.campaignId}`;
        break;
      // case 'ADREQUEST':
      //   eventAction += eventData.adtype;
      //   break;
      case 'ADLOADED':
        eventAction += eventData.adtype;
        break;
      default:
        eventAction += isAutoplayOn ? 'autoplay' : 'user-initiated';
        eventAction += `/${currentVideoURL}`;
    }

    eventAction += `${'/_'}${agency}`;

    const playerState =
      (TimesApps.VideoPlayerAudio &&
        TimesApps.VideoPlayerAudio.getPlayerState()) ||
      '';
    if (playerState === (TimesApps.FLAGS && TimesApps.FLAGS.REPLAY)) {
      eventAction += '/_replay';
    } else if (playerState === TimesApps.FLAGS.NEXT_VIDEO) {
      eventAction += '/_next_video';
    }

    //flash players don't provide streamType data, adaptive will be used in such cases
    const streamingtype =
      eventData.videoStream ||
      eventData.kalstream ||
      (eventData.type ? eventData.type[2] : false) ||
      '';
    let playertype;
    if (
      eventData.contentid ||
      eventData.videoStream ||
      (eventData.type ? eventData.type[1] : false)
    ) {
      //these properties are only
      //available in case of html5 player
      playertype = 'html';
    }

    if (eventCat === 'ADVIEW') {
      // console.log('**** is Ad type HLS -', eventData.isHls);
    }
    const eventLabelData = [];
    if (
      eventData.source === 'articleshow' &&
      (eventData.userInitiated === '0' || eventData.userInitiated === '')
    ) {
      eventLabelData.push('AS_AUTOPLAY');
    } else {
      eventLabelData.push(videoLocationOnPage);
    }

    if (eventType !== 'FULLSCREEN_ON') {
      if (playertype) {
        eventLabelData.push(playertype);
      }
      if (streamingtype) {
        eventLabelData.push(streamingtype);
      }
    }

    //console.log("Video_GA_Fired.... "+eventCat);
  };

  // /**
  //  * Consrtructor for the strategy. This is what gets passed to the SDK via:
  //  * window['_cbv_strategies'].push(AudioStratgey);
  //  * @param {Object} player A pointer to the player being tracked. The player
  //  * is where all the video data is derived from
  //  */
  function AudioStratgey(player) {
    // Your constructor code goes here
    this.player_ = player;
    this.ready_ = false;
    this.adData = {
      isPlaying: false,
      adType: '',
    };
    this.subscribeEvents_();
  }
  TimesApps.getPlayerConfig = function getPlayerConfig() {
    // let pageType = mainConfig.pageType || '';
    // pageType = pageType.toUpperCase();
    // const section = mainConfig.section || TimesApps.getPageLocation() || '';
    const volume = TimesApps.Vod_Player.getVolume();
    const { slikeApiKey } = mainConfig;
    // let nextVideoUrl;

    // let agency = mainConfig.agency || '';
    // const regex = new RegExp(' ', 'g');

    // agency = agency.replace(regex, '');
    const { msid } = mainConfig;
    const { mediaId } = mainConfig;
    // let playerId = mainConfig.playerid;
    // playerId = parseInt(playerId, 10) === 10 ? playerId : 0;
    // const nextVideoCounter = mainConfig.nextVideoCounter || 5;
    //var allowDim = document.getElementById("allowDim").value || false;
    // const allowDim = parseInt(mainConfig.allowDim, 10) === 1;
    const source = mainConfig.source ? mainConfig.source.toUpperCase() : '';
    let conf;
    if (source.indexOf('ABOVEARTICLE') > -1) {
      //above article video, has values like ABOVEARTICLE_0, ABOVEARTICLE_1..
      conf = TimesApps.VOD_CONF.ABOVEARTICLE;
    } else if (source.indexOf('PRIME_TOPVOD') > -1) {
      conf = TimesApps.VOD_CONF.PRIME_TOPVOD;
    } else {
      conf = TimesApps.VOD_CONF[source] || TimesApps.VOD_CONF._default;
    }

    // const showNextPrevButton =
    //   typeof conf.showNextPrevButton === 'undefined' || conf.showNextPrevButton;
    // const showPrevButton =
    //   typeof conf.showPrevButton === 'undefined' || conf.showPrevButton;

    // let bgImage = TimesApps.AudioUtils.getVideoImg();

    // const { sectionId } = mainConfig;

    // if (conf && conf.nextVideoUrl && typeof conf.nextVideoUrl === 'string') {
    //   if (conf.nextVideoUrl.indexOf('videpostroll_v8') > -1) {
    //     nextVideoUrl = `${getSiteDomain()}${conf.nextVideoUrl +
    //       msid}.cms?feedtype=json&dontshow=${msid}&callback=cached`;
    //   } else if (source.indexOf('ARTICLE') >= 0) {
    //     let articleMsid = window.parent.msid;
    //     if (
    //       typeof articleMsid === 'object' &&
    //       articleMsid.getAttribute('value')
    //     ) {
    //       articleMsid = articleMsid.getAttribute('value') || '';
    //     }
    //     nextVideoUrl = `${conf.nextVideoUrl +
    //       articleMsid}.cms?feedtype=json&dontshow=${msid}&callback=cached`;
    //   } else {
    //     nextVideoUrl = `${conf.nextVideoUrl +
    //       msid}.cms?feedtype=json&dontshow=${msid}&callback=cached`;
    //   }
    //   bgImage = undefined;
    // }
    const dmpCookieValue = Cookie.get('_col_uuid');
    const configObj = {
      cookieId: dmpCookieValue,
      apiKey: slikeApiKey,
      // height: '100%',
      // width: '100%',
      origin: `${window.location.protocol}//${window.location.host}`,
      referrer: document.referrer,
      msid,
      //css: "position:absolute;width:100%;height:100%",
      video: {
        //image: bgImage,
        id: slikeId,
      },
      controls: {
        ui: 'podcast',
        // showPipIcon: false,
        // offlineVolume: false,
        // offlineMute: false,
        // hideCenterIcon: conf.hideCenterIcon,
        // showNextButton: isMobileMode ? false : showNextPrevButton,
        // showPrevButton: isMobileMode
        //   ? false
        //   : showPrevButton && showNextPrevButton,
        // showAutoPlayNext: conf.showAutoPlayNext,
        // showFwdSeek: conf.showFwdSeek,
        // showBackSeek: conf.showBackSeek,
        // mute: conf.mute,
        // autoPlayNext: conf.autoPlayNext,
        // showWave: false, //conf.showWave,
        // duration: conf.duration,
        // showShare: conf.showShare,
      },
      player: {
        // tryHlsAds: true,
        // portOut: 'pause',
        // portIn: 'play',
        // copyConfig: true,
        // startFromSec: 0,
        // iphoneinline: true,
        // isGAPlugin: false,
        // iphonefs: false,
        // showLastFrame: conf.showLastFrame,
        //custom start point
        // nextVideoList:
        //   nextVideoMsidArray instanceof Array
        //     ? nextVideoMsidArray.splice(1, nextVideoMsidArray.length - 1)
        //     : [],
        // audioMode: true,
        // audioPrime: true,
        // autoPlay: conf.autoPlay,
        // autoPlayAudio: conf.autoPlayAudio,
        // forceWA: conf.forceWA,
        // fallbackMute: false,
        // volume,
        id: mediaId,
        autoPlay: conf.autoPlay,
        fallbackMute: true,
        mute: conf.mute,
        skipAd: true,
        playInBackground: true,
        // adSection: j,
        volume,
        // tpAds: ['dm'],
        // pagetpl: k,
        pageSection: TimesApps.getPageLocation(),
        scrollBehaviour: {
          inViewPercent: 50,
          dock: false,
          autoPlay: false,
          autoPause: false,
        },
      },
      /* playerVars: {
        image: bgImage,
        playerid: playerId,
        // sg: TimesApps.AudioUtils.getAdsTargetParams(),
        cc: TimesApps.userLocation.getCountryFromSessionStorage(),
        time: new Date(),
        apikey: slikeApiKey,
        section,
        pid: agency || 'TNN',
        pagesection: TimesApps.getPageLocation(),
        autoStart: true,
        id: mediaId,
        title: mainConfig.title,
        nextVideoCounter: conf.nextVideoCounter,
        nextVideoUrl,
        msid,
        // shareurl: '',
        settings: {
          //for showing next video on autoplay
          autoplay: true,
          volume,
          //mute: TimesApps.Vod_Player.isMute()
          mute: TimesApps.AudioPlayerUtils.isMute(),
        },
        controls: {
          dim: allowDim,
          fullscreen: true,
          adplaypause: true,
          // share: !isMobileMode,
          autoplay: conf.showAutoplayButton,
          hideCenterIcon: true,
          //'controlsHide': ['dim','autoplay','fullscreen','bitrate','volumebar','keyshortcut','share']
        },
      },*/
      // events: TimesApps.audioPlayerCallbacks,
    };
    // if (navigator.userAgent.indexOf('UCBrowser') !== -1) {
    //   configObj.playerVars.settings.autoplay = false;
    // }

    // if (
    //   TimesApps.VOD_CONF[source] &&
    //   TimesApps.VOD_CONF[source].showVolumeSeekBar
    // ) {
    //   configObj.playerVars.controls.showVolumeSeekBar = true;
    // }

    //document.domain = 'indiatimes.com';
    // configObj.playerVars.shareurl = TimesApps.AudioUtils.getVideoUrl();
    return configObj;
  };
  TimesApps.Chartbeat = (function Chartbeat() {
    // let fn, api, bindEvents;
    const _addPlayerToConfig = function _addPlayerToConfig() {
      setTimeout(() => {
        const config = TimesApps.getPlayerConfig();
        const _cbv = window._cbv || (window._cbv = []);
        _cbv.push(config);
      }, 0);
    };
    /*const _loadChartbeat = function _loadChartbeat() {
      window._sf_endpt = new Date().getTime();
      const playerJs = document.createElement('script');
      playerJs.src = '//static.chartbeat.com/js/chartbeat_video.js';
      //playerJs.src = "//s3.amazonaws.com/static.chartbeat.com/js/chartbeat_video.js";
      // const scriptTag = document.getElementsByTagName('script')[0];
      const onChartbeatLoad = function onChartbeatLoad() {
        _addPlayerToConfig();
      };

      TimesApps.loadJs(playerJs.src, onChartbeatLoad, '');
    };*/
    const bindEvents = function bindEvents() {
      if (TimesApps.AudioUtils.checkGdprAndCall) {
        TimesApps.AudioUtils.checkGdprAndCall(_addPlayerToConfig, null);
      }

      /*$(document).ready(function(){

          })*/

      /*var pubSub = TimesApps.PubSub;
          pubSub.subscribe("slikeVideoLoaded", function(data){
              fn._addPlayerToConfig();
          });*/
    };
    const fn = {
      _init() {
        /****************************************************************************************************/

        /****************************************************************************************************/
        window._sf_async_config = window._sf_async_config || {};
        window._sf_async_config.uid = '10538';
        window._sf_async_config.domain = 'timesofindia.indiatimes.com';
        window._sf_async_config.autoDetect = false;
        fn._prepareData();
        bindEvents();
      },
      _prepareData() {
        window._cbv_strategies = window._cbv_strategies || [];
        window._cbv_strategies.push(AudioStratgey);
      },
    };
    const api = {};
    fn._init();
    return api;
  })();

  // /**
  //  * Enum for the content type. One of these values should be returned from
  //  * the "getContentType" function.
  //  * @enum {string}
  //  */
  AudioStratgey.ContentType = {
    AD: 'ad',
    CONTENT: 'ct',
  };

  // /**
  //  * Enum for the ad position. One of these values should be returned from
  //  * the "getAdPosition" function.
  //  * @enum {string}
  //  */
  // AudioStratgey.AdPosition = {
  //   PREROLL: 'a1',
  //   MIDROLL: 'a2',
  //   POSTROLL: 'a3',
  //   OVERLAY: 'a4',
  //   SPECIAL: 'a5',
  // };

  // /**
  //  * Enum for the video state. One of these values should be returned from
  //  * the "getState" function.
  //  * @enum {string}
  //  */
  AudioStratgey.VideoState = {
    UNPLAYED: 's1',
    PLAYED: 's2',
    STOPPED: 's3',
    COMPLETED: 's4',
  };

  AudioStratgey.prototype.subscribeEvents_ = function subscribeEvents_() {
    const pubSub = TimesApps.PubSub;
    pubSub.subscribe('VOD_EVENTS', data => {
      if (!(data instanceof Array) && data.length > 0) {
        return;
      }
      const eventData = data[0] || {};
      const eventType = data[1] ? data[1].toUpperCase() : '';
      this.adData.adType = (eventData.adtype || '').toUpperCase();

      if (this.adData.isAdPlaying) {
        return;
      }

      switch (eventType) {
        case 'VIDEOREADY':
          this.onPlaybackReady_();
          break;
        case 'VIDEOVIEW':
          this.onVideoPlay_();
          break;
        case 'AUDIOREADY':
          this.onPlaybackReady_();
          break;
        case 'AUDIOVIEW':
          this.onVideoPlay_();
          break;
        default:
      }
    });
  };

  // /**
  //  * Handle when the video is ready for playback
  //  * @private
  //  */
  AudioStratgey.prototype.onPlaybackReady_ = function onPlaybackReady_() {
    //console.log('**********************************AudioStratgey::onPlaybackReady_');
    this.ready_ = true;
  };

  // /**
  //  * Handle when the video is played
  //  * @private
  //  */
  AudioStratgey.prototype.onVideoPlay_ = function onVideoPlay_() {
    //console.log('**********************************AudioStratgey::onVideoPlay_');
    this.videoStartTime_ = Date.now();
    this.videoPlayed_ = true;
  };

  // /**
  //  * Indicates if the video strategy is ready for pinging.
  //  * Typically this is called when all path and title metadata
  //  * is available
  //  * Note: Pings should only be sent after this reads true.
  //  * @return {boolean} The ready state of the strategy.
  //  */
  AudioStratgey.prototype.isReady = function isReady() {
    // As an example, this could just be a call to a similar
    // method in your _player object
    // this._player.isready();
    //console.log("***************  isReady called *****************************");
    return this.ready_;
  };

  /*AudioStratgey.verify = function verify(player) {
    // console.log(player, TimesApps.getPlayerConfig());
    try {
      return player.playerVars.id === TimesApps.getPlayerConfig().playerVars.id;
    } catch (e) {
      // console.log(e);
      // console.log(player, TimesApps.getPlayerConfig());
      return false;
    }
  };*/

  // /**
  //  * Gets the video path.
  //  * This is returned in the p key of the ping.
  //  * Note: this should be the playable video path if available.
  //  * @return {string} The video path.
  //  */
  AudioStratgey.prototype.getVideoPath = function getVideoPath() {
    //console.log("***************  getVideoPath called *****************************");
    return TimesApps.getPlayerConfig().player.id;
  };

  // /**
  //  * Gets the type of video playing. Returns value from the ContentType enum.
  //  * This is returned in the _vt key of the ping.
  //  * @return {YourStrategy.ContentType} The type of content (ad or ct).
  //  */
  AudioStratgey.prototype.getContentType = function getContentType() {
    if (this.adData.isAdPlaying) {
      return AudioStratgey.ContentType.AD;
      //console.log("***************  getContentType called -" + AudioStratgey.ContentType.AD +"*****************************");
    }
    //console.log("***************  getContentType called " + AudioStratgey.ContentType.CONTENT +"*****************************");
    return AudioStratgey.ContentType.CONTENT;
  };

  // AudioStratgey.prototype.getAdPosition = function getAdPosition() {
  //   let adPosition;
  //   switch (this.adData.adType) {
  //     case 'MID':
  //       adPosition = AudioStratgey.AdPosition.PREROLL;
  //       break;
  //     default:
  //   }
  //   //console.log("***************  getAdPosition called,"+ adPosition +"*****************************");
  //   return adPosition;
  // };

  AudioStratgey.prototype.getState = function getState() {
    // const FLAGS = TimesApps.FLAGS;
    const playerState = TimesApps.VideoPlayerAudio.getPlayerState() || '';
    let state;
    if (this.adData.isAdPlaying) {
      //in case of ads
      //paused is to be sent
      state = AudioStratgey.VideoState.STOPPED;
    } else {
      switch (playerState) {
        case TimesApps.FLAGS.READY:
          state = AudioStratgey.VideoState.UNPLAYED;
          break;
        case TimesApps.FLAGS.PLAYING:
          state = AudioStratgey.VideoState.PLAYED;
          break;
        case TimesApps.FLAGS.PAUSED:
          state = AudioStratgey.VideoState.STOPPED;
          break;
        case TimesApps.FLAGS.COMPLETED:
          state = AudioStratgey.VideoState.COMPLETED;
          break;
        default:
          state = AudioStratgey.VideoState.STOPPED;
      }
    }

    //console.log("***************  getState called," + state + "*****************************");
    return state;
  };

  AudioStratgey.prototype.getStrategyName = function getStrategyName() {
    return 'VS';
  };

  AudioStratgey.prototype.getTitle = function getTitle() {
    //console.log("***************  getTitle called *****************************");
    return mainConfig.title || '';
  };

  // AudioStratgey.prototype.getThumbnailPath = function getThumbnailPath() {
  //   //console.log("***************  getThumbnailPath *****************************");
  //   return TimesApps.AudioUtils.getVideoImg(mainConfig.akamaiCacheBlockingImg) || '';
  // };

  AudioStratgey.prototype.getTotalDuration = function getTotalDuration() {
    //console.log("***************  getTotalDuration called - " + TimesApps.Vod_Player.getDurationinMs() + "*****************************");
    return TimesApps.Vod_Player.getDurationinMs();
  };

  AudioStratgey.prototype.getCurrentPlayTime = function getCurrentPlayTime() {
    const playerName =
      (TimesApps.audioPlayer && TimesApps.audioPlayer.playerName) || '';
    const player = TimesApps.VideoPlayerAudio.getPlayer(playerName);
    const currentPlayTimeInS =
      player && player.getCurrentPosition && player.getCurrentPosition();
    //console.log("***************  getCurrentPlayTime -" + Math.round(currentPlayTimeInS * 1000) + "*****************************");
    return Math.round(currentPlayTimeInS * 1000);
  };

  AudioStratgey.prototype.getViewStartTime = function getViewStartTime() {
    return 0;
  };

  TimesApps.iBeatVideoCall = (function iBeat() {
    const fn = {
      _getParentUrl() {
        let url = '';
        try {
          url = window.parent.location.href;
        } catch (e) {
          url = window.location.href;
        }

        return url;
      },
      _loadiBeat() {
        const pageConfig = {
          channel: mainConfig.agency || 'timesofindia.indiatimes.com',
          action: 1,
          articleId: mainConfig.articleId || '',
          contentType: 2,
          location: 1,
          url: fn._getParentUrl(),
          cat: mainConfig.navSecName,
          subcat: mainConfig.navSubSecName,
          contenttag: mainConfig.metaKeywords || '',
          catIds: mainConfig.navCatIds || '',
          articledt: mainConfig.articledt || '',
          author: '',
        };

        if (window.TimesApps.iBeat && window.TimesApps.iBeat.sendIBeatCall) {
          window.TimesApps.iBeat.sendIBeatCall(pageConfig);
        }
      },
    };

    const api = {
      loadiBeat() {
        return fn._loadiBeat();
      },
    };
    return api;
  })();

  // document.domain = 'indiatimes.com';
  TimesApps.audioPlayer = {
    playerName: 'VOD',
    playerNameConstant: '',
  };

  TimesApps.userLocation = (function userLocation() {
    /*also in toi_js */
    // let fn, api, config, dataState;

    const dataState = {
      countryCode: '',
    };

    const config = {
      COUNTRY_CODE_LOCALSTORAGE_KEY: 'countryCode',
    };

    const fn = {
      _getCountryFromSessionStorage() {
        if (dataState.countryCode) {
          return dataState.countryCode;
        }
        let countryCode = false;
        let data =
          TimesApps.AudioUtils.getDataFromWebStorage(
            config.COUNTRY_CODE_LOCALSTORAGE_KEY,
          ) || {};

        try {
          data = JSON.parse(data);
        } catch (e) {
          //console.log("json error");
          return countryCode;
        }

        if (typeof data !== 'undefined' && data != null && data.countryCode) {
          countryCode = data.countryCode;
        }

        dataState.countryCode = countryCode;

        return dataState.countryCode;
      },

      _setCountryInLocalStorage(countryCode) {
        let data = {
          countryCode,
          timestamp: new Date().getTime(),
        };
        data = JSON.stringify(data);
        dataState.countryCode = countryCode;
        TimesApps.AudioUtils.setIntoWebStorage(
          config.COUNTRY_CODE_LOCALSTORAGE_KEY,
          data,
        );
      },
      _geoUserGA(eventType) {
        //GA
        (function publishFoundUsercountry() {
          const { playerName } = TimesApps.audioPlayer;
          const pubSub = TimesApps.PubSub;
          const eventData = {};
          eventData.loadStatus = eventType || '';
          eventData.source = mainConfig.source;
          eventData.stream = 'CONTENT';
          eventData.userInitiated = mainConfig.userInitiated || '';
          eventData.id = mainConfig.msid || '';
          pubSub.publish(`${playerName}_EVENTS`, [
            eventData,
            'foundUsercountry'.toUpperCase(),
          ]);
        })();
      },
      _getUserCountry() {
        const pubSub = TimesApps.PubSub;
        let countryCode = fn._getCountryFromSessionStorage();
        if (countryCode !== '' && countryCode) {
          fn._geoUserGA('load_browserStorage');
          pubSub.publish('foundUsercountry', countryCode);
        } else {
          const geoApiOnLoad = function geoApiOnLoad(event) {
            const { geoinfo } = window;
            countryCode = geoinfo?.CountryCode;
            if (countryCode) {
              fn._setCountryInLocalStorage(countryCode);
            }
            fn._geoUserGA((event && event.type) || '');
            pubSub.publish('foundUsercountry', countryCode);
          };
          TimesApps.loadJs('//geoapi.indiatimes.com/?cb=1', geoApiOnLoad, '');
        }

        return countryCode;
      },
    };

    const api = {
      getUserCountry() {
        return fn._getUserCountry();
      },
      getCountryFromSessionStorage() {
        return fn._getCountryFromSessionStorage();
      },
    };

    return api;
  })();

  TimesApps.Vod_Player = (function Vod_Player() {
    // "use strict";

    // var api, fn, util, config, data, constants;

    const config = {
      dataStorageKey: 'vodPLayer',
    };

    const constants = {
      seondsInOneMinute: 60,
      msInOneSecond: 1000,
    };

    const defaultData = {
      isMute: false,
      nextVideoList: [],
    };

    const util = {
      _getData() {
        let data;
        try {
          data = JSON.parse(
            TimesApps.AudioUtils.getDataFromWebStorage(config.dataStorageKey) ||
              '{}',
          );
        } catch (e) {
          data = {};
        }
        return data;
      },
      _storeData(prop, value) {
        if (typeof prop === 'undefined' || prop.trim().length === 0) {
          return undefined;
        }

        const data = util._getData();
        data[prop] = value;

        let dataJson;

        try {
          dataJson = JSON.stringify(data);
        } catch (e) {
          return false;
        }

        TimesApps.AudioUtils.setIntoWebStorage(config.dataStorageKey, dataJson);
        return data;
      },
      isImaLoaded() {
        if (typeof window.ima === 'object' && window.ima.common) {
          return true;
        }
        return false;
      },
    };

    const fn = {
      _checkGeoAndAddPlayer() {
        const isSlikeLoaded = TimesApps.VideoPlayerAudio.isSlikeLoaded();
        // const country = TimesApps.userLocation.getCountryFromSessionStorage();
        if (!isSlikeLoaded /*|| !country*/) {
          return;
        }
        // if (
        //   !(TimesApps.googleImaJsLoaded && TimesApps.slikeImaWrapperJsLoaded)
        // ) {
        //   return;
        // }
        const playerConfig = TimesApps.getPlayerConfig();
        const { playerName } = TimesApps.audioPlayer;
        TimesApps.VideoPlayerAudio.addPlayer(divId, playerConfig, playerName);
      },
      _getNextVideoData(nextVideoMsid) {
        if (!nextVideoMsid || !nextVideoMsid.trim().length) {
          return;
        }

        //http://toidev.indiatimes.com
        // const url = '';
        makeRequest
          .get(
            `/feeds/videomediainfo_v1/msid-${nextVideoMsid},feedtype-json.cms`,
            {},
            'skipfeedengine',
          )
          .then(response => {
            const { playerName } = TimesApps.audioPlayer;
            videoDataReceivedCallback(response.data.item);
            const eventData = response.data.item || {};
            eventData.source =
              TimesApps.audioPlayer.playerNameConstant + playerName;
            eventData.stream = 'CONTENT';
            eventData.userInitiated = mainConfig.userInitiated;

            const eventType = 'onNextVideoDataFetch';
            const pubSub = TimesApps.PubSub;
            pubSub.publish(`${playerName}_EVENTS`, [eventData, eventType]);
            triggerEvent(`${playerName}_EVENTS`, [eventData, eventType]);
          })
          .catch(err => {
            console.log(err);
          });
      },
      _updateMainConfigWithAjaxData(data) {
        mainConfig.msid = data.msid;
        mainConfig.mediaId = data.embedId;
        mainConfig.playerid = data.playerid;
        mainConfig.title = data.title;
        //document.getElementById("bgImage").value = ;
        mainConfig.seoLocation = data.seopath;
        mainConfig.breadCrumb = `${data.seopath.split('/')[0]}.${
          data.seopath.split('/')[1]
        }`;
        mainConfig.agency = data.agency || '';
        let date;
        if (data.videodatetime && data.videodatetime.indexOf(':')) {
          let splitDate = data.videodatetime.split(':')[0].split(' ');
          if (splitDate.length > 1) {
            splitDate.pop();
          }
          if (typeof splitDate === 'string') {
            splitDate = splitDate.split(',')[0];
          }
          date = splitDate.join(' ');
        } else {
          date = data.videodatetime;
        }
        mainConfig.mediaDate = date;

        mainConfig.articleId = data.msid || '';
        mainConfig.subcat = data.section || '';
        mainConfig.metaKeywords = data.keyword || '';
        mainConfig.articledt = data.videodatetime || '';
        mainConfig.blacklistText = data.blacklistText || '';
        mainConfig.navSecName = data.navsectionname || '';
        mainConfig.navSubSecName = data.navsubsectionname || '';
        mainConfig.navCatIds = data.navcatids || '';
        mainConfig.specialId__hyp1 = data.specialId || '';
      },
      _updateData(data) {
        TimesApps.playingSubsequentVideo = true;
        TimesApps.Vod_Player.updateMainConfigWithAjaxData(data);
        const pubSub = TimesApps.PubSub;
        const { playerName } = TimesApps.audioPlayer;
        pubSub.publish(`${playerName}_EVENTS`, [{}, 'onNextVideoDataUpdate']);
      },
      _updateVolume(volume) {
        //TimesApps.Vod_Player.updateVolume
        const volumeData = {
          value: volume,
          updateTime: new Date().getTime(),
        };
        util._storeData('volume', volumeData);
      },
      _getVolume() {
        let volume;
        const volumeObj = util._getData().volume || {};
        const msIn30Mins =
          30 * constants.seondsInOneMinute * constants.msInOneSecond;
        if (
          typeof volumeObj === 'undefined' ||
          typeof volumeObj.value === 'undefined'
        ) {
          volume = mainConfig.volume;
        } else if (new Date().getTime() + msIn30Mins < volumeObj.updateTime) {
          //volume was saved 30 back
          //expire volume
          volume = mainConfig.volume;
          util._storeData('volume', {});
        } else {
          volume = volumeObj.value;
        }
        return volume;
      },
      _mutePlayer(shouldMute) {
        defaultData.isMute = shouldMute;
      },
      _isMute() {
        return defaultData.isMute;
      },
      _formatDataIntoSlikeObj(response) {
        let data;
        let nextVideoData;
        try {
          if (typeof response.data === 'object') {
            data = response.data;
          } else {
            data = JSON.parse(response.data);
          }
        } catch (e) {
          return nextVideoData;
        }
        nextVideoData = {
          embedId: data.item.embedId,
          kalturaid: data.item.embed,
          imagepath: data.item.thumburl,
          id: data.item.msid,
          playerid: data.item.playerid,
          title: {
            vdtitle: data.item.title,
          },
          agency: data.item.agency || '',
          msid: `/videos${data.item.seopath}/videoshow/${data.item.msid}.cms`,
          description: data.item.description,
        };

        return nextVideoData;
      },
      _getNextVideo(nextVideoMsid) {
        if (!nextVideoMsid || !nextVideoMsid.trim().length) {
          return;
        }

        makeRequest
          .get(
            `/feeds/videomediainfo_v1/msid-${nextVideoMsid},feedtype-json.cms`,
            {},
            'skipfeedengine',
          )
          .then(response => {
            videoDataReceivedCallbackWrapper(response.data.item);
            const nextVideoData = fn._formatDataIntoSlikeObj(response);
            mainConfig.nextVideoURL = nextVideoData.msid;
            TimesApps.VideoPlayerAudio.setNextVideo(
              [nextVideoData],
              TimesApps.audioPlayer.playerName,
            );
            mainConfig.nextid = '';
          });
      },
      _addNextVideoToList(msid) {
        defaultData.nextVideoList.push(msid);
      },
      _getNextVideoId() {
        return defaultData.nextVideoList.shift();
      },
      _getDurationinMs() {
        return TimesApps.convertMinutesToMs(mainConfig.duration);
      },
      _addLastFrameStyle(sourcevalue) {
        try {
          let conf = {};
          // const sourceElem = document.getElementById('source');
          const pubSub = TimesApps.PubSub;
          // const sourceVal =
          //   sourceElem && sourceElem.value
          //     ? sourceElem.value.toUpperCase()
          //     : '';
          if (sourcevalue.indexOf('PRIME_TOPVOD') > -1) {
            conf = TimesApps.VOD_CONF.PRIME_TOPVOD;
          }
          if (!conf.showLastFrame) {
            return;
          }

          const vodEventsListener = pubSub.subscribe('VOD_EVENTS', data => {
            if (!(data instanceof Array) && data.length > 0) {
              return;
            }
            const eventType = data[1] ? data[1].toUpperCase() : '';
            const videoListElem = document.getElementById(divId);
            if (eventType === 'VIDEOVIEW' || eventType === 'AUDIOVIEW') {
              // eslint-disable-next-line no-unused-expressions
              videoListElem &&
                videoListElem.classList.add('lastFramePrimeOpacity');
              pubSub.unsubscribe(vodEventsListener);
            }
          });
        } catch (e) {
          // console.log(e);
        }
      },
    };

    const api = {
      checkGeoAndAddPlayer() {
        fn._checkGeoAndAddPlayer();
      },
      formatDataIntoSlikeObj(data) {
        return fn._formatDataIntoSlikeObj(data);
      },
      getNextVideoData(nextVideoMsid) {
        return fn._getNextVideoData(nextVideoMsid);
      },
      getVolume() {
        return fn._getVolume();
      },
      updateVolume(volume) {
        return fn._updateVolume(volume);
      },
      mutePlayer(shouldMute) {
        return fn._mutePlayer(shouldMute);
      },
      isMute() {
        return fn._isMute();
      },
      updateMainConfigWithAjaxData(data) {
        return fn._updateMainConfigWithAjaxData(data);
      },
      updateData(data) {
        return fn._updateData(data);
      },
      getNextVideo(nextVideoMsid) {
        return fn._getNextVideo(nextVideoMsid);
      },
      addNextVideoToList(msid) {
        return fn._addNextVideoToList(msid);
      },
      getNextVideoId() {
        return fn._getNextVideoId();
      },
      getDurationinMs() {
        return fn._getDurationinMs();
      },
      addLastFrameStyle(sourceval) {
        return fn._addLastFrameStyle(sourceval);
      },
    };
    // api.addLastFrameStyle();
    return api;
  })();

  if (window.location.href.indexOf('toidev') >= 0) {
    TimesApps.isDevMode = 1;
  }
  const pubSub = TimesApps.PubSub;
  TimesApps.Vod_Player.addLastFrameStyle(sourceVal);
  pubSub.subscribe('VOD_EVENTS', data => {
    if (!(data instanceof Array) && data.length > 0) {
      return;
    }

    const eventData = data[0] || {};
    const eventType = data[1] ? data[1].toUpperCase() : '';
    const { playerName } = TimesApps.audioPlayer;
    if (eventType === 'VIDEOVIEW' || eventType === 'AUDIOVIEW') {
      triggerEvent(`${playerName}_EVENTS`, [eventData, eventType]);
      const nextVideoMsid = TimesApps.Vod_Player.getNextVideoId();
      TimesApps.Vod_Player.getNextVideo(nextVideoMsid);
      TimesApps.iBeatVideoCall.loadiBeat();
      try {
        videoWatchPoints(mainConfig.msid, isWapView);
      } catch (err) {
        console.log(err);
      }
    } else if (eventType === 'ONNEXTVIDEOPLAY' && eventData.source !== 'MG') {
      setTimeout(
        function getNextVideoData() {
          TimesApps.Vod_Player.getNextVideoData(this.nextVideoData.msid);
          mainConfig.msid = this.nextVideoData.msid;
          const isUserInitiated =
            eventData.userInitiated && eventData.userInitiated !== 'false'
              ? true
              : '';
          mainConfig.userInitiated = isUserInitiated;

          if (
            typeof window.parent.TimesApps !== 'undefined' &&
            typeof window.parent.TimesApps.VideoGalleryApp !== 'undefined'
          ) {
            //taking status from VideoGalleryApp
            const videoList = window.parent.sTimesApps.VideoGalleryApp.getVideoList();
            const videoId = this.nextVideoData.source
              ? this.nextVideoData.source.toUpperCase()
              : '';
            const video = videoList[videoId];

            if (typeof video !== 'undefined' && video.setAutoPlay) {
              video.setAutoPlay(!isUserInitiated);
            }
          }

          if (eventData.source === 'MG_0') {
            //MG_0 is top video on HP
            //different section value is
            //neeeded for video other than 1st
            mainConfig.section = 'homepage.top-rest-videos';
          }
        }.bind({
          nextVideoData: {
            msid: eventData.msid,
            source: eventData.source,
          },
        }),
        0,
      );
    } else if (eventType === 'ONNEXTVIDEODATAFETCH') {
      TimesApps.Vod_Player.updateData(eventData);
    } else if (eventType === 'START') {
      TimesApps.VideoStarted = true;
    } else if (
      eventType === 'ONVOLUMECHANGE' &&
      TimesApps.VideoPlayerAudio.getPlayer('VOD').getCurrentPosition() > 0
    ) {
      //temporary hack, until Slike team
      //fixes onVolume change event
      // --> should not fire, during video start
      //as user did not change volume
      if (eventData.muted) {
        TimesApps.Vod_Player.mutePlayer(true);
      } else {
        TimesApps.Vod_Player.updateVolume(eventData.volume);
        TimesApps.Vod_Player.mutePlayer(false);
      }
    } else if (eventType === 'VIDEOCOMPLETE' || eventType === 'AUDIOCOMPLETE') {
      //temporary hack, until Slike team
      //fixes onVolume change event
      TimesApps.VideoStarted = false;
    } else if (eventType === 'ONNEXTVIDEODATAUPDATE') {
      TimesApps.AudioUtils.fireVideoRequestGA();
    }

    TimesApps.prepareComscoreDataAndFireReq({}, eventData, eventType);
    TimesApps.prepareDataForGA({}, eventData, eventType);
  });

  window._poc = window._poc || {};
  const checkIfVideoCanAutoplayWithVolume = function checkIfVideoCanAutoplayWithVolume(
    cid,
    ms,
    _poc,
  ) {
    const _pocNew = _poc || window._poc;
    // _poc = _poc || window._poc;
    const videoTag = document.createElement('video');
    const c = document.getElementById(cid);
    if (c != null) {
      c.appendChild(videoTag);
    }
    videoTag.id = 'dummyV';
    /*if(SPL&&SPL.UA&&(SPL.UA.getBrowser().name=="Safari"||SPL.UA.getOS().name=='iOS'))
      videoTag.src="#";
      else*/
    videoTag.src = window.S.dummyMp4;
    videoTag.style.height = '1px';
    videoTag.style.width = '1px';
    videoTag.volume = 0.02;
    videoTag.muted = false;
    videoTag.style.opacity = 0;
    videoTag.setAttribute('playsinline', '');
    videoTag.setAttribute('webkit-playsinline', '');

    if (ms === true) {
      videoTag.muted = true;
    }
    const sampleVideo = videoTag.play();
    if (sampleVideo !== undefined) {
      sampleVideo.then(
        () => {
          const volume = TimesApps.Vod_Player.getVolume();
          //if(TimesApps.isDevMode){
          // console.log('promise success, adding vol', volume);
          //}
          // Automatic playback started!
          const { playerName } = TimesApps.audioPlayer;
          if (isUserPrime) {
            TimesApps.VideoPlayerAudio.getPlayer(playerName).mute(false);
          }
          TimesApps.VideoPlayerAudio.getPlayer(playerName).setVolume(volume);
        },
        e => {
          // Automatic playback failed.
          console.log('Video play failed', e);
        },
      );
    } else if (videoTag.paused) {
      //Safari < 10
      _pocNew.userClick = false;
    } else {
      //IE < 11
      _pocNew.userClick = true;
    }
    return videoTag;
  };

  const checkIfVideoCanAutoplayWithVolumeEvent = pubSub.subscribe(
    'VOD_EVENTS',
    data => {
      if (!(data instanceof Array) && data.length > 0) {
        return;
      }

      const eventType = data[1] ? data[1].toUpperCase() : '';
      const videoInitEvents = ['VIDEOREADY', 'AUDIOREADY', 'ADVIEW'];
      if (videoInitEvents.indexOf(eventType) === -1) {
        return;
      }
      pubSub.unsubscribe(checkIfVideoCanAutoplayWithVolumeEvent);

      try {
        setTimeout(checkIfVideoCanAutoplayWithVolume, 50);
      } catch (e) {
        console.log('promise failed');
      }
    },
  );

  function triggerPlayerLoaded() {
    //trigger mini tv player loaded event
    const eventData = {};
    const { playerName } = TimesApps.audioPlayer;
    eventData.source = mainConfig.source;
    eventData.msid = mainConfig.msid;
    eventData.domSelector = window.frameElement
      ? window.frameElement.getAttribute('id')
      : '#streaming_box #player';
    eventData.userInitiated = mainConfig.userInitiated || false;
    const eventType = `${playerName}_LOADED`;
    //var pauseVideoCallBack = TimesApps.VideoPlayerAudio.getPlayer(playerName).pause;
    const pauseVideoCallBack = TimesApps.VideoPlayerAudio.pause;
    pauseVideoCallBack.bind({
      playerName,
    });
    triggerEvent(`${playerName}_LOADED`, [
      eventData,
      eventType,
      pauseVideoCallBack,
    ]);
  }

  // const pubSub = TimesApps.PubSub;
  pubSub.subscribe('slikeVideoLoaded', () => {
    triggerPlayerLoaded();
    pubSub.unsubscribe('slikeVideoLoaded');
  });

  function onVideoUnmount() {
    //pause video if iframe is about to exit
    const { playerName } = TimesApps.audioPlayer;
    const pauseVideoCallBack = TimesApps.VideoPlayerAudio.getPlayer(playerName)
      ? TimesApps.VideoPlayerAudio.getPlayer(playerName).pause
      : false;
    if (pauseVideoCallBack) {
      pauseVideoCallBack();
    }

    const eventData = {};
    eventData.source = mainConfig.source;
    eventData.stream = 'CONTENT';
    eventData.userInitiated = mainConfig.userInitiated;
    const eventType = 'videoIframeRemoved';
    triggerEvent(`${playerName}_EVENTS`, [eventData, eventType]);
  }
  onVideoUnmount.abc = '';

  TimesApps.getPageLocation = function getPageLocation() {
    return mainConfig.breadCrumb;
  };

  TimesApps.prepareComscoreDataAndFireReq = function prepareComscoreDataAndFireReq(
    event,
    eventData,
    eventType,
  ) {
    const parentWindow = window.parent;
    if (typeof parentWindow === 'undefined') {
      return;
    }
    const config = {
      comscoreCustomerId: '6036484',
      stationTitle: 'TOI-Desktop',
      publisherName: 'The Times of India',
      contentGenre: 'News',
      c3: '10',
    };
    let contentType = eventData.stream || '';
    contentType = contentType.toUpperCase();
    const trackingDetails = {};
    trackingDetails.contentGenre = config.contentGenre;

    trackingDetails.seoLocation = mainConfig.seoLocation;
    const date = mainConfig.mediaDate;
    trackingDetails.airDate = date;
    const videoObj = eventData || {};
    videoObj.pdata = {};
    videoObj.id = TimesApps.getPlayerConfig().msid;
    //converting to mins
    //remove once all videos are migrated to Slike
    videoObj.duration = (videoObj.duration || 0) / 60;
    videoObj.title = mainConfig.title;
    // videoObj.pdata.adposition = eventData.adtype;

    trackingDetails.c3 = config.c3;
    fireComscoreTrackingRequest(
      config.comscoreCustomerId,
      eventType,
      contentType,
      config.stationTitle,
      config.publisherName,
      trackingDetails,
      videoObj,
    );
  };
  function VideoSubscribe(videoData) {
    TimesApps.Vod_Player.updateMainConfigWithAjaxData(videoData);
    TimesApps.AudioUtils.fireVideoRequestGA();
    pubSub.subscribe('slikeLoaded', TimesApps.Vod_Player.checkGeoAndAddPlayer);
    pubSub.subscribe(
      'googleImaJsLoaded',
      TimesApps.Vod_Player.checkGeoAndAddPlayer,
    );
    pubSub.subscribe(
      'slikeImaWrapperJsLoaded',
      TimesApps.Vod_Player.checkGeoAndAddPlayer,
    );
    // pubSub.subscribe('foundUsercountry', () => {
    //   const country = TimesApps.userLocation.getCountryFromSessionStorage();
    //   if (country && country !== '') {
    //     TimesApps.Vod_Player.checkGeoAndAddPlayer();
    //     return;
    //   }
    //   pubSub.unsubscribe('foundUsercountry');
    // });

    TimesApps.userLocation.getUserCountry();
    TimesApps.VideoPlayerAudio.init();

    const nextVideoMsid = mainConfig.nextid;
    if (nextVideoMsid) {
      //TimesApps.Vod_Player.addNextVideoToList(nextVideoMsid);
    }
  }

  makeRequest
    .get(
      `/feeds/videomediainfo_v1/msid-${videoMsid},feedtype-json.cms`,
      {},
      'skipfeedengine',
    )
    .then(response => {
      VideoSubscribe(response.data.item);
      videoDataReceivedCallbackWrapper(response.data.item);
      const nextVideoData = TimesApps.Vod_Player.formatDataIntoSlikeObj(
        response,
      );
      const vodEventsListener = pubSub.subscribe('VOD_EVENTS', data => {
        if (!(data instanceof Array) && data.length > 0) {
          return;
        }
        const eventType = data[1] ? data[1].toUpperCase() : '';
        if (eventType === 'VIDEOREADY' || eventType === 'AUDIOREADY') {
          TimesApps.VideoPlayerAudio.setCurrentVideoInPlaylist(
            [nextVideoData],
            TimesApps.audioPlayer.playerName,
          );
          pubSub.unsubscribe(vodEventsListener);
        }
      });
    })
    .catch(err => {
      console.log('video error0', err);
      // if(slikeId) {
      //   VideoSubscribe({embedId: slikeId,seopath: ''})
      // }
    });

  // VideoSubscribe();
  let previousVideoMsid = videoMsid;
  function subscribeToStore() {
    const getNextVideoMsidFromState = state => {
      if (state.videoshow && state.videoshow.msidForNextVideo) {
        return state.videoshow.msidForNextVideo;
      }
      if (state.articleshow && state.articleshow.msidForNextVideo) {
        return state.articleshow.msidForNextVideo;
      }
      if (state.articleshow_v2 && state.articleshow_v2.msidForNextVideo) {
        return state.articleshow_v2.msidForNextVideo;
      }
      if (state.homepage && state.homepage.msidForNextVideo) {
        return state.homepage.msidForNextVideo;
      }
      if (state.homepage_us && state.homepage_us.msidForNextVideo) {
        return state.homepage_us.msidForNextVideo;
      }
      return undefined;
    };

    if (typeof store === 'object' && typeof store.subscribe === 'function') {
      store.subscribe(() => {
        const nextMsid = getNextVideoMsidFromState(store.getState());
        if (
          parseInt(nextMsid, 10) !== parseInt(previousVideoMsid, 10) &&
          nextMsid
        ) {
          previousVideoMsid = nextMsid;
          TimesApps.Vod_Player.addNextVideoToList(nextMsid);
          // TimesApps.Vod_Player.getNextVideo
          //TimesApps.Vod_Player.getNextVideo(nextMsid);
        }
      });
    }
  }
  subscribeToStore();
}
